import { render, staticRenderFns } from "./nodata_200_h.vue?vue&type=template&id=18698fe0&scoped=true&"
import script from "./nodata_200_h.vue?vue&type=script&lang=js&"
export * from "./nodata_200_h.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18698fe0",
  null
  
)

export default component.exports